module.exports = __webpack_public_path__ + "static/img/banner.88ca416.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new_image/banner.png
// module id = Mps8
// module chunks = 20